import { Component, Input, inject } from '@angular/core';
import {ProjectAttribute} from '../../models/project-attribute';
import {NgControl} from '@angular/forms';
import {NOOP_VALUE_ACCESSOR} from '../../utils/noop-value-accessor';
import {ProjectAttributeOption} from '../../models/project-attribute-option';

@Component({
    selector: 'app-attribute-project-editable',
    templateUrl: './attribute-project-editable.component.html',
    standalone: false
})
export class AttributeProjectEditableComponent {
    ngControl = inject(NgControl, { self: true });

    options: { key: string; value: string }[] = [];
    get attribute(): ProjectAttribute | null {
        return this._attribute;
    }

    @Input()
    set attribute(value: ProjectAttribute | null) {
        this._attribute = value;
        if (value !== null) {
            // this.options = value.values.map(it => ({ key: it.id, value: it.title}));
            this.options = this.sortDataByParentChildRelation(value.values);
        }
    }

    @Input() label: string | undefined;
    @Input() private _attribute: ProjectAttribute | null = null

    constructor() {
        if (this.ngControl) {
            // Note: we provide the value accessor through here, instead of
            // the `providers` to avoid running into a circular import.
            // And we use NOOP_VALUE_ACCESSOR so WrappedInput don't do anything with NgControl
            this.ngControl.valueAccessor = NOOP_VALUE_ACCESSOR;
        }
    }

    getSelectedValue(attribute: ProjectAttribute) {
        const selectedOptions = attribute.values.filter(value => {
            const controlValue: string | string[] | null = this.ngControl.value;
            return Array.isArray(controlValue)
                ? controlValue.includes(value.id)
                : value.id == this.ngControl.value;
        })

        return selectedOptions.map(option => option.title).join(', ') || '-'
    }

    private sortDataByParentChildRelation(data: ProjectAttributeOption[]): { key: string, value: string }[] {
        const sortedList: { key: string, value: string }[] = [];
        const parentIdToChild: { [parentId: string]: ProjectAttributeOption[] } = {};

        data.forEach(item => {
            if (item.parentIds.length > 0) {
                item.parentIds.forEach(parentId => {
                    if (!parentIdToChild[parentId]) {
                        parentIdToChild[parentId] = [];
                    }
                    parentIdToChild[parentId].push(item);
                });
            }
        });

        function sortByVolgorde(a: ProjectAttributeOption, b: ProjectAttributeOption) {
            return (a.order ?? 0) - (b.order ?? 0);
        }

        function addItemToList(item: ProjectAttributeOption) {
            sortedList.push({key: item.id, value: item.title});
            if (parentIdToChild[item.id]) {
                parentIdToChild[item.id].sort(sortByVolgorde).forEach(child => {
                    addItemToList({...child, title: `${item.title} / ${child.title}`});
                });
            }
        }

        data
            .filter(item => item.parentIds.length === 0)
            .sort(sortByVolgorde)
            .forEach(item => {
                addItemToList(item);
            });

        const parentIds = Object.keys(parentIdToChild);
        return sortedList.filter(it => !parentIds.includes(it.key));
    }
}
